import React from 'react';
import { RefererSummary } from '../../model/StockReferer';
import moment from 'moment';
import SortableTable from '../table/SortableTable';

interface IProps{
    referers: RefererSummary[]
}

const getHeaders = () => ['Referrer', 'Count', 'Endpoints', 'First', 'Last'];
const LastIndex = 4;

const ReferersItem:React.FC<IProps> = (props:IProps) => {
    const style:any = { 'fontSize': '0.75rem', 'marginLeft': '1rem'}

    const data: any[][] = [];
    for(let referer of props.referers){
        const arr: any[] = [
            referer.url,
            referer.count,
            Object.keys(referer.endpoints || {}).sort().join(', '),
            referer.first,
            referer.last,
            referer
        ]
        data.push(arr);
    }

    const cellFormatter = (columnName: string, cell: any, referer: RefererSummary): React.ReactNode => {
        if(columnName === 'Referrer'){
            const displayUrl = referer.url.length > 120
                ? referer.url.substring(0, 120) + '...'
                : referer.url;
            return <a href={referer.url} target='_blank' rel="noreferrer" title={referer.url}>{displayUrl}</a>
        }
        else if(columnName === 'Endpoints'){
            const endpoints = referer.endpoints || {};
            const title = Object.keys(endpoints).sort().map(x => `${x}: ${moment(endpoints[x]).format('DDMMMYY HH:mm')}`).join('\n');
            return <span style={style} title={title}>{cell}</span>
        }
        else if(columnName === 'First'){
            return <span style={style}>{moment(cell).format('DDMMMYY')}</span>
        }
        else if(columnName === 'Last'){
            return <span style={style}>{moment(cell).format('DDMMMYY')}</span>
        }
        return null;
    }

    return <SortableTable headers={getHeaders()} data={data} cellFormatter={cellFormatter} sortIndex={LastIndex} sortDirection="desc" />
}

export default ReferersItem;
